import React from 'react'

import { ForgotPassword } from '../components/Auth/ForgotPassword'
import { UnauthenticatedLayout } from '../layouts/Unauthenticated.layout'

export const ForgotPasswordPage: React.FC = () => {
    return (
        <UnauthenticatedLayout>
            <ForgotPassword />
        </UnauthenticatedLayout>
    )
}
